export default __webpack_public_path__ + "static/media/bloed-plast.311ee610.svg";